// extracted by mini-css-extract-plugin
export default {"ctn":"Sec_ctn__uj1Id","wrapper":"Sec_wrapper__btEhV","left":"Sec_left__tD6QK","right":"Sec_right__DzErj"};